<div class="d-lg-none">
  <fgb-page-header pageTitle="{{ 'checkout.page.title' }}" [showBalance]="false" [showBanner]="false"></fgb-page-header>
</div>
<div class="container">
  <div class="row">
    <div class="col-lg-7 col-12 mt-4 text-white">
      <h4 class="fw-bold font-size-18">{{ 'cart.itemsSummary' | translate }}</h4>
      <div class="mb-4 mt-4">
        <div class="column cart-item-list">
          @for (item of items(); track item.id) {
            <div class="d-flex flex-row mx-0 cart-item" [routerLink]="['/rewards/marketplace/details', item.productData.Id]">
              <img
                alt=""
                class="rounded cursor-pointer"
                src="{{ item.productData.ImageURL | contentImage: '6' }}"
                [routerLink]="['/rewards/marketplace/details', item.productData.Id]"
              />
              <div class="flex-column w-100 ms-3 position-relative">
                <div class="d-flex flex-row justify-content-between text-start">
                  <p
                    class="font-size-14 fw-bold mb-1 cursor-pointer"
                    [routerLink]="['/rewards/marketplace/details', item.productData.Id]"
                  >
                    {{ item.productData.DisplayName }}
                  </p>
                </div>
                <div *ngIf="item.attributes" class="d-flex flex-row mb-1">
                  <div class="text-start font-size-12 ps-0 text-nowrap mb-0 me-4">
                    <span class="fw-bold">{{ item.attributes.Label }}: </span> {{ item.attributes.DisplayName }}
                  </div>
                </div>
                <div *ngIf="item.customFields" class="d-flex flex-row flex-wrap mb-1">
                  <!-- For each custom Field-->
                  <div *ngFor="let customField of item.customFields">
                    <div *ngIf="customField.customFieldValue" class="text-start font-size-12 ps-0 me-4 mb-0">
                      <span class="fw-bold">{{ customField.customFieldName }}: </span> {{ customField.customFieldValue }}
                    </div>
                  </div>
                </div>
                <div class="d-flex flex-row justify-content-between">
                  <div class="d-flex align-items-center flex-row w-100">
                    <div class="text-start font-size-12 ps-0 text-nowrap align-items-center d-flex">
                      <p class="mb-0 me-1 fw-bold">{{ 'cart.quantity' | translate }}</p>
                      <p class="mb-0">{{ item.purchaseQuantity }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
      <button class="btn text-primary fw-bold ps-0 go-back-btn" (click)="goBack()">
        <span class="font-size-14 text-go-back">{{ 'cart.goBack' | translate }}</span>
      </button>
    </div>
    <div class="col-lg-5 col-12 mt-4">
      <!--member details address-->
      <div class="container address-container py-2 mb-3" [ngClass]="{ 'd-none': editingMemberAddress }">
        <div class="position-relative rounded p-2">
          <div class="d-flex justify-content-between">
            <h4 class="text-white font-size-14">Billing address</h4>
            <h4 class="cursor-pointer font-size-14" (click)="editMemberAddress()">
              {{ 'billing.address.edit' | translate }}
            </h4>
          </div>
          <div class="row">
            <div class="col-10">
              <span *ngIf="memberDetails()" class="font-size-14 mb-0 d-flex text-white">
                <div>{{ memberDetails().Street }},&nbsp;</div>
                <div>{{ memberDetails().Town }},&nbsp;</div>
                <div>{{ memberDetails().County }},&nbsp;</div>
                <div>{{ memberDetails().Country }},&nbsp;</div>
                <div>{{ memberDetails().PostCode }},&nbsp;</div>
                <div>{{ memberDetails().HomeNumber }}</div>
              </span>
            </div>
          </div>
        </div>
      </div>
      <!--EO member details address view-->

      <!-- EDIT MEMBER DETAILS ADDRESS FORM -->
      <ng-container *ngIf="editingMemberAddress">
        <div class="container address-container mb-3">
          <div class="position-relative p-2">
            <div class="d-flex justify-content-between">
              <h4 class="text-white font-size-14 pt-2 mb-3">Address</h4>
              <a (click)="clearAddressForm()" class="text-primary heading-text-one mb-1 pt-2 font-size-14 cursor-pointer fw-bold"
                >Clear Form</a
              >
            </div>
            <div [formGroup]="checkoutForm">
              <form formGroupName="address" class="font-size-12">
                <!--Street-->
                <div class="form-group form-floating">
                  <input
                    id="Street"
                    class="form-control"
                    name="Street"
                    type="text"
                    formControlName="Street"
                    [ngClass]="{
                      'is-invalid': hasSubmittedMemberAddress && checkoutForm.get('address.Street')?.invalid,
                    }"
                    required
                  />
                  <label for="Street">
                    <span>Street</span>
                  </label>
                  <div class="invalid-feedback">Please enter a valid street.</div>
                </div>
                <!--City-->
                <div class="form-group form-floating my-2">
                  <input
                    id="Town"
                    class="form-control"
                    name="Town"
                    type="text"
                    formControlName="Town"
                    [ngClass]="{
                      'is-invalid': hasSubmittedMemberAddress && checkoutForm.get('address.Town')?.invalid,
                    }"
                    required
                  />

                  <label for="Town">
                    <span>City</span>
                  </label>
                  <div class="invalid-feedback">Please enter a valid city.</div>
                </div>
                <!--Country and region-->
                <fgbcl-country-and-regions
                  [SeparateRow]="true"
                  [Form]="checkoutForm.get('address')"
                  [HasSubmitted]="hasSubmittedMemberAddress"
                ></fgbcl-country-and-regions>
                <!--Zip code-->
                <div class="form-group form-floating">
                  <input
                    id="Postcode"
                    class="form-control"
                    name="Postcode"
                    type="text"
                    formControlName="PostCode"
                    [ngClass]="{
                      'is-invalid': hasSubmittedMemberAddress && checkoutForm.get('address.PostCode')?.invalid,
                    }"
                    required
                  />

                  <label for="Postcode">
                    <span>Zip Code</span>
                  </label>
                  <div class="invalid-feedback">Please enter a valid zip code.</div>
                </div>
                <!--Phone-->
                <div class="form-group form-floating mt-2">
                  <input
                    id="HomeNumber"
                    class="form-control"
                    name="HomeNumber"
                    type="text"
                    formControlName="HomeNumber"
                    required
                    onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                    minlength="8"
                    maxlength="11"
                    [ngClass]="{
                      'is-invalid': hasSubmittedMemberAddress && checkoutForm.get('address.HomeNumber')?.invalid,
                    }"
                  />
                  <label for="Country">
                    <span>Phone Number</span>
                  </label>
                  <div class="invalid-feedback">Please enter a valid phone number.</div>
                </div>
              </form>
            </div>

            <div class="d-flex justify-content-end justify-content-lg-between my-2 mt-3 font-size-14">
              <button class="btn btn-primary fw-bold btn-cancel-save me-2 font-size-14" (click)="cancelAndRebuildForm()">
                Cancel
              </button>
              <button class="btn btn-quaternary fw-bold btn-cancel-save font-size-14" (click)="saveMemberDetailAddress()">
                Save
              </button>
            </div>
          </div>
        </div>
      </ng-container>
      <!--EO edit member details address-->
      <!--summary of items in basket-->
      @if (items()?.length > 0) {
        <div class="container address-container p-3">
          <h4 class="text-white fw-bold font-size-14">{{ 'cart.summary' | translate }}</h4>
          <div class="row">
            @if (checkoutSummary().merchantItems.totalPrice > 0 || checkoutSummary().productItems.totalPrice > 0) {
              <div class="col-6 fw-bold font-size-14">
                <span class="fw-normal">{{ 'cart.currency.items' | translate }}</span>
              </div>
              <div class="col-6 font-size-14 text-end pr-4">
                {{
                  (checkoutSummary().merchantItems.totalPrice + checkoutSummary().productItems.totalPrice) / 100
                    | FortressCurrencyPipe
                }}
              </div>
            }
            @if (checkoutSummary().pointsItems.totalPoints > 0) {
              <div class="col-6 fw-bold font-size-14">
                <span class="fw-normal">{{ 'cart.point.items' | translate }}</span>
              </div>
              <div class="col-6 font-size-14 text-end pr-4">
                {{ checkoutSummary().pointsItems.totalPoints | FortressCurrencyPipe: 'PTS' }}
              </div>
            }
            @if (orderPreview()?.Summary.TaxMerchant > 0) {
              <div class="col-6 fw-bold font-size-14">
                <span class="fw-normal">{{ 'summary.tax' | translate }}</span>
              </div>
              <div class="col-6 font-size-14 text-end pr-4">
                {{ orderPreview()?.Summary.TaxMerchant / 100 | FortressCurrencyPipe }}
              </div>
            }
          </div>
          <hr class="w-100" />
          <div class="d-flex flex-column">
            <div class="d-flex justify-content-between align-items-center">
              <div class="fw-bold font-size-14">{{ 'cart.summary.totalMerchant' | translate }}</div>
              <div class="d-flex align-items-center">
                <div class="fw-bold font-size-14 text-end">
                  @if (orderPreview()?.Summary.BasketTotalMerchant > 0 && orderPreview()?.Summary.TotalPoints > 0) {
                    {{ orderPreview()?.Summary.BasketTotalMerchant / 100 | FortressCurrencyPipe }} +
                    {{ orderPreview()?.Summary.TotalPoints | FortressCurrencyPipe: 'PTS' }}
                  } @else if (orderPreview()?.Summary.BasketTotalMerchant > 0) {
                    {{ orderPreview()?.Summary.BasketTotalMerchant / 100 | FortressCurrencyPipe }}
                  } @else if (orderPreview()?.Summary.TotalPoints > 0) {
                    {{ orderPreview()?.Summary.TotalPoints | FortressCurrencyPipe: 'PTS' }}
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      }

      <div class="payment-type-container">
        <h4 class="text-white fw-bold font-size-14">{{ 'cart.payment' | translate }}</h4>
        @if (checkoutSummary().merchantItems.totalPrice > 0 || checkoutSummary().productItems.totalPrice > 0) {
          @if (cardInfo()?.CardNumber) {
            <div class="card-infor">
              <p class="font-size-14 mb-0">
                {{ 'cart.card_infor' | translate }}
                <span class="card-number">({{ cardInfo()?.CardNumber | creditCardNumber: 'true' }})</span>
              </p>
              <img alt="imagedetails" class="card-type-image me-3" src="{{ cardInfo()?.CardType | cardTypeImageUrl }}" />
            </div>
            <div class="px-0 mt-3">
              <button
                class="btn btn-quaternary fw-bold mt-2 w-100 paynow-btn d-flex justify-content-center"
                (click)="payNow()"
                [disabled]="items()?.length === 0"
              >
                @if (items()?.length === 0) {
                  {{ 'checkout.empty-basket' | translate }}
                } @else {
                  {{ 'checkout-claim-now' | translate }}
                }
                <div *ngIf="loading" class="ms-2">
                  <fgbcl-loading size="small"></fgbcl-loading>
                </div>
              </button>
              <div class="separator pt-1">
                <span class="mx-2 seperator-text text-white">{{ 'cart.seperator' | translate }}</span>
              </div>
              <button
                (click)="openCartAddPaymentDetailModal(saveAsCardToken)"
                [disabled]="loading || !checkoutForm?.valid"
                class="btn btn-tertiary border-grey fw-bold mt-2 w-100 addcard-btn text-white"
              >
                {{ 'cart.add_new_payment_method' | translate }}
              </button>
            </div>
            <div class="checkbox-container d-flex justify-content-left align-items-center">
              <input type="checkbox" [(ngModel)]="saveAsCardToken" [disabled]="loading" />
              <p class="description">{{ 'cart.save_payment_card' | translate }}</p>
            </div>
          } @else {
            <button
              class="btn btn-tertiary border-grey fw-bold mt-2 w-100 addcard-btn text-white"
              (click)="openCartAddPaymentDetailModal(saveAsCardToken)"
              [disabled]="!checkoutForm?.valid"
            >
              {{ 'cart.add_new_card' | translate }}
            </button>
            <div class="checkbox-container d-flex justify-content-left align-items-center">
              <input type="checkbox" [(ngModel)]="saveAsCardToken" />
              <p class="description">{{ 'cart.save_payment_card' | translate }}</p>
            </div>
          }
        } @else {
          <button
            class="btn btn-quaternary fw-bold mt-2 w-100 paynow-btn d-flex justify-content-center"
            (click)="payNow()"
            [disabled]="items()?.length === 0"
          >
            @if (items()?.length === 0) {
              {{ 'checkout.empty-basket' | translate }}
            } @else {
              {{ 'checkout-claim-now' | translate }}
            }
            <div *ngIf="loading" class="ms-2">
              <fgbcl-loading size="small"></fgbcl-loading>
            </div>
          </button>
        }
      </div>

      <fgbcl-errors></fgbcl-errors>
      @if (checkoutForm.hasError('hasDisabledItems')) {
        <div class="alert alert-danger">{{ 'cart.disabled.items.error' | translate }}</div>
      } @else if (checkoutForm.hasError('insufficientBalance')) {
        <div class="alert alert-danger">{{ 'cart.insufficient.balance.error' | translate }}</div>
      } @else if (checkoutForm.hasError('invalidAddress') && checkoutForm.get('address')?.touched) {
        <div class="alert alert-danger">{{ 'cart.invalid.address.error' | translate }}</div>
      }
    </div>
  </div>
</div>
